import { apiClient } from '_app'
import { CancelToken } from 'axios'
import { ApiResponse } from 'dtos'
import { ConformityListDto, ReadyToSendDto, ReadyToSendVehicleDto, ReadyToSignDto, SentToDOTDto } from 'dtos/conformity'
import { ConformityListContext } from 'enums/conformity'
import { download, openInNewTab, URIQuery } from 'utils'

const baseUrl = (): string => '/api/conformity'

export const getConformityLists = (cancelToken?: CancelToken) => apiClient.get<ApiResponse<ConformityListDto>>(baseUrl(), { cancelToken }).then(res => res.data)

export const getReadyToSign = (parameters: { order?: string; orderBy?: string }, cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<ReadyToSignDto[]>>(`${baseUrl()}/ready-to-sign` + URIQuery(parameters), { cancelToken }).then(res => res.data)

export const createFilesToSign = (values: ReadyToSignDto[], cancelToken?: CancelToken) =>
  apiClient.post<ApiResponse<ConformityListDto>>(`${baseUrl()}/create-files-to-sign`, values, { cancelToken }).then(res => res.data)

export const getReadyToSend = (cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<ReadyToSendDto[]>>(`${baseUrl()}/ready-to-send`, { cancelToken }).then(res => res.data)

export const saveReadyToSendVehicles = (values: ReadyToSendVehicleDto[], sentToDOT: boolean, cancelToken?: CancelToken) =>
  apiClient.post<ApiResponse<ConformityListDto>>(`${baseUrl()}/ready-to-send` + URIQuery({ sentToDOT }), values, { cancelToken }).then(res => res.data)

export const getSummarySheet = (inboundTripGuid: string, fileName: string, context: ConformityListContext, cancelToken?: CancelToken) =>
  apiClient.get<Blob>(`${baseUrl()}/summary-sheet` + URIQuery({ inboundTripGuid, context }), { cancelToken, responseType: 'blob' }).then(res => {
    download(res.data, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
  })

export const getConformityZipPreview = (vehicleGuid: string, cancelToken?: CancelToken) =>
  apiClient.get<string>(`${baseUrl()}/conformity-zip-preview` + URIQuery({ vehicleGuid }), { cancelToken }).then(res => {
    openInNewTab(res.data, 'application/pdf')
  })

export const getConformtyZip = (vehicleGuid: string, fileName: string, cancelToken?: CancelToken) =>
  apiClient.get<string>(`${baseUrl()}/conformity-zip` + URIQuery({ vehicleGuid }), { cancelToken }).then(res => {
    download(res.data, fileName, 'application/zip')
  })

export const getSentToDOT = (cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<SentToDOTDto[]>>(`${baseUrl()}/sent-to-dot`, { cancelToken }).then(res => res.data)
